export default "__VITE_ASSET__hRaVF4Fw__"